import { getOrdersOrderIdFee } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { UserPermissions } from "Infrastructure/Api/permissions";
import { hasPermission } from "Infrastructure/Utilities/Permissions/hasPermission";
import { useQuery } from "@tanstack/react-query";

export const getOrderFeeQueryKey = (orderId: number) => ["ORDER_FEE", orderId];

export function useOrderFeeQuery(orderId: number) {
	return useQuery({
		queryKey: getOrderFeeQueryKey(orderId),
		queryFn: processResponse(() => getOrdersOrderIdFee(orderId)),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
		enabled: !!orderId && hasPermission(UserPermissions.OrderFeeModule.read),
	});
}
